import { render, staticRenderFns } from "./lanTingUserAgreement.vue?vue&type=template&id=5f893352&scoped=true&"
import script from "./lanTingUserAgreement.vue?vue&type=script&lang=js&"
export * from "./lanTingUserAgreement.vue?vue&type=script&lang=js&"
import style0 from "./lanTingUserAgreement.vue?vue&type=style&index=0&id=5f893352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f893352",
  null
  
)

export default component.exports